<template>
    <div class="col-md-12" v-if="cartao">
        <div class="row">
            <div class="col-md-9">
                <b-card outlined>
                    <b-card-text>
                        <div class="row">
                            <div class="col-md-9">
                                <div class="form-group" v-if="cartao.executor">
                                    <span v-b-tooltip.hover.top :title="permissao() ? 'Clique para alterar o gestor' : ''"
                                        role="button" @click.prevent="
                                            permissao()
                                                ? setCurrentModal({
                                                    id: 'gestor',
                                                    title: 'Alterar o Gestor',
                                                    size: 'sm',
                                                    btn_save: true,
                                                    form: 'gestorForm',
                                                    component: {
                                                        props: {
                                                            cartao: cartao,
                                                        },
                                                    },
                                                    bvModal: $bvModal,
                                                })
                                                : ''
                                            ">

                                        <strong>Gestor:</strong>
                                        {{
                                            cartao.executor.devolver_executor
                                            ? cartao.executor.devolver_executor.name
                                            : cartao.executor.colaborador.name
                                        }}
                                    </span>
                                    <span role="button" @click="departamento_id = cartao.executor.colaborador.time_id; $bvModal.show('departamento-select')"  v-if="(cartao.executor.devolver_executor &&
                                                cartao.executor.devolver_executor.time_id) ||
                                            cartao.executor.colaborador.time_id
                                            "><strong class="ml-5">Departamento:</strong>
                                        {{
                                            cartao.executor.devolver_executor &&
                                            cartao.executor.devolver_executor.time &&
                                            cartao.executor.devolver_executor.time.nome
                                            ? cartao.executor.devolver_executor.time.nome
                                            : cartao.executor.colaborador && cartao.executor.colaborador.time && cartao.executor.colaborador.time.nome
                                                ? cartao.executor.colaborador.time.nome
                                                : ""
                                        }}
                                    </span>

                                </div>

                                <label class="tarefa-label">ID {{ cartao.tarefa_id }} - Título:
                                </label>



                                <strong role="button" v-b-tooltip.hover.top title="Clique para alterar o título."
                                    @click.prevent="TitleInput = true" v-if="!TitleInput && !!cartao.titulo">{{
                                        cartao.titulo }}</strong>

                                <strong v-if="cartao.processo">Processo:
                                    {{ cartao.processo.processo_numero }}/{{ cartao.processo.processo_ano }} -
                                    {{ cartao.processo.tipo ? cartao.processo.tipo.tipo : '' }} </strong>
                                <div class="input-group mb-3" v-if="!!TitleInput">
                                    <input class="form-control" type="text" name="titulo" v-model="cartao.titulo"
                                        placeholder="Insira um título para esta tarefa" required="" />
                                    <div class="input-group-append">
                                        <button v-if="!!cartao.titulo && cartao.titulo.length > 3" @click.prevent="
                                            TitleInput = false;
                                        updateCartao();
                                        " class="btn btn-default">
                                            Salvar
                                        </button>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <categoria type="text" v-if="cartao.categoria_id != null"
                                            @resetCategoria="cartao.categoria_id = null">
                                            {{ cartao.categoria.nome }}
                                        </categoria>
                                        <categoria v-else-if="cartao.categoria_id == null" @setCategoria="setCategoria"
                                            type="select" />
                                    </div>
                                    <div class="col-md-6">
                                        <subcategoria v-if="cartao.subcategoria_id != null"
                                            :categoria_id="cartao.categoria_id"
                                            @resetSubcategoria="cartao.subcategoria_id = null" type="text">
                                            {{ cartao.subcategoria.nome }}
                                        </subcategoria>
                                        <subcategoria v-else-if="cartao.categoria_id != null"
                                            :categoria_id="cartao.categoria_id" type="select"
                                            @setSubcategoria="setSubcategoria" />
                                    </div>
                                    <div class="col-md-6" v-if="permissao()">
                                        <div class="form-group">
                                            <label class="tarefa-label">Data de Entrega: </label>
                                            <span v-b-tooltip.hover.top title="Alterar data e hora de entrega"
                                                class="data-entrega" role="button" v-if="!data_input"
                                                @click.prevent="data_input = true">
                                                {{
                                                    moment(
                                                        cartao.data_devolucao
                                                            ? cartao.data_devolucao
                                                            : cartao.data_entrega
                                                    ).format("LLLL")
                                                }}
                                            </span>
                                            <div class="input-group mb-3" v-if="!!data_input">
                                                <date-picker placeholder="Selecione a data e hora" format="DD-MM-YYYY HH:mm"
                                                    v-model="cartao.data_entrega" type="datetime"></date-picker>
                                                <div class="input-group-append">
                                                    <button v-if="!!cartao.data_entrega" @click.prevent="
                                                        data_input = false;
                                                    updateCartao();
                                                    " class="btn btn-default">
                                                        Salvar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="cartao.data_devolucao" class="col-md-6">
                                        <div class="form-group">
                                            <label class="tarefa-label">Data de Devolução: </label>
                                            <span>{{
                                                moment(cartao.data_devolucao).format("LLLL")
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div role="button" v-b-tooltip.hover.top :title="permissao() && !cartao.date_end
                                            ? 'clique para alterar a previsão de duração'
                                            : ''
                                        " @click.prevent="
            permissao() && !cartao.date_end
                ? setCurrentModal({
                    id: 'duracao',
                    title: 'Alterar previsão de duração',
                    size: 'sm',
                    btn_save: true,
                    form: 'duracaoForm',
                    component: {
                        props: {
                            cartao: cartao,
                        },
                    },
                    bvModal: $bvModal,
                })
                : ''
            ">
                                    <span class="d-flex justify-content-between" v-if="!duracao_input"><span><i
                                                class="fas fa-clock"></i> Previsão de duração:</span>
                                        <span>{{ cartao.duracao ? cartao.duracao : "0" }} dias</span></span>

                                    <span class="d-flex justify-content-between"><span><i class="fas fa-stopwatch"></i>
                                            Tempo decorrido:</span>
                                        <span :class="verificarStatusColorTempoDecorrido()">{{ cartao.tempo_decorrido }}
                                            dias</span></span>
                                    <span class="d-flex justify-content-between"><span>Percentual decorrido:</span>
                                        <span :class="verificarStatusColorTempoDecorrido()">{{
                                            cartao.tempo_decorrido_percentual }} %</span></span>
                                    <strong v-if="cartao.date_end">Arquivado</strong>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-card>
                <div v-if="cartao.executor">
                    <div class="etiquetas d-flex flex-column mb-3" v-if="!!cartao.executor.situacao">
                        <label>Colaborador / Situação</label>
                        <div>
                            <b-button v-b-tooltip.hover.left
                                :title="`${cartao.executor.colaborador.name} / Alterar Situação`" type="button" :style="`
                                  background-color: ${cartao.executor.situacao.cor};
                                  color: white;
                                  text-transform: uppercase;
                                `" @click.prevent="
                                    setCurrentModal({
                                        id: 'situacao',
                                        title: 'Alterar Situação',
                                        size: 'sm',
                                        component: {
                                            props: {
                                                tarefa_id: cartao.tarefa_id,
                                            },
                                        },
                                        bvModal: $bvModal,
                                    })
                                    ">
                                <span class="thumb_executor">{{
                                    cartao.executor.colaborador.name
                                        .split(/\s/)
                                        .reduce(
                                            (response, word) => (response += word.slice(0, 1)),
                                            ""
                                        )
                                        .substring(0, 2)
                                }}</span>
                                /
                                <span class="text">{{ cartao.executor.situacao.nome }}</span>
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="tarefa-label"><i class="fa fa-align-justify"></i> Descrição</label>
                    <div class="descricao" role="button" v-b-tooltip.hover title="Clique para editar a descrição."
                        v-html="cartao.descricao" v-show="editar_descricao == false || cartao.date_end"
                        @click.prevent="editar_descricao = true"></div>

                    <div v-show="editar_descricao == true && !cartao.date_end">
                        <trumbowyg v-model="cartao.descricao" :config="editor_config" @tbw-paste="trumbowygPaste"
                            class="form-control" name="content">
                        </trumbowyg>
                    </div>

                    <button class="btn btn-default btn-descricao" @click.prevent="updateDescricao()"
                        v-if="editar_descricao && !cartao.date_end">
                        Salvar
                    </button>
                </div>
                <div class="form-group">
                    <label class="tarefa-label"><i class="fa fa-comment"></i> Comentários</label>
                    <Comentario v-if="cartao.tarefa_id" :tarefa_id="cartao.tarefa_id"></Comentario>
                    <Comentarios v-if="cartao.tarefa_id" :tarefa_id="cartao.tarefa_id" @updateCartao="getCartao(true)"></Comentarios>
                </div>
                <div class="form-group">
                    <checklists v-if="!!cartao.checklists && cartao.checklists.length > 0" :checklists="cartao.checklists"
                        :cartao="cartao" @updateCartao="updateCartao" />
                </div>
                <div class="form-group" v-if="cartao.anexos && cartao.anexos.length > 0">
                    <label class="tarefa-label"><i class="fas fa-paperclip"></i> Anexos</label>
                    <Anexos :tarefa_id="cartao.tarefa_id" :cliente_documento="cartao.cliente_documento"
                        parent_name="tarefas" :parent_id="cartao.tarefa_id" :custom_anexos="cartao.anexos" />
                    <b-button variant="outline-secondary" type="button" size="sm" v-if="!cartao.date_end" @click.prevent="
                        setCurrentModal({
                            id: 'anexos',
                            title: `Anexos do Cliente: ${cartao.cliente.razao_social != null &&
                                cartao.cliente.razao_social != ''
                                ? cartao.cliente.razao_social
                                : cartao.cliente.nome_loja
                                }`,
                            component: {
                                props: {
                                    tarefa_id: cartao.tarefa_id,
                                    parent_name: 'tarefas',
                                    parent_id: cartao.tarefa_id,
                                    showForm: true,
                                    selecionar: true,
                                    BlockThisAnexos: cartao.anexos,
                                    cliente_documento: cartao.cliente_documento,
                                },
                            },
                            bvModal: $bvModal,
                        })
                        ">
                        <i class="fas fa-upload"></i> Adicionar anexo
                    </b-button>
                </div>
            </div>
            <div class="col-md-3">
                <strong style="font-size: 16px">AÇÕES</strong>
                <div v-if="!cartao.date_end">
                    <div class="form-group">
                        <div class="form-group" v-if="user.user_id == 7 || user.user_parent_id == 7">
                            <b-button v-b-tooltip.hover.left :variant="cobranca_btn_colors" block title="Serviços da tarefa"
                                @click.prevent="
                                    $bvModal.show('servicos')
                                    ">
                                <i class="fa fa-dollar-sign"></i> COBRANÇAS
                            </b-button>
                        </div>
                        <div class="form-group">
                            <b-button v-b-tooltip.hover.left v-if="cartao.executor == null ||
                                cartao.executor.devolver_user_id == null
                                " title="Encaminhar tarefa" variant="outline-secondary" @click.prevent="
        setCurrentModal({
            id: 'encaminhar',
            title: `Encaminhar tarefa: ${cartao.titulo}`,
            form: 'formEncaminhar',
            size: 'md',
            btn_save: true,
            btn_save_name: 'Encaminhar',
            component: {
                props: {
                    tarefa_id: cartao.tarefa_id,
                    cartao_data_entrega: cartao.data_entrega,
                },
            },
            bvModal: $bvModal,
        })
        " type="button" block :disabled="cartao.executor &&
        cartao.executor.devolver_user_id != null &&
        cartao.executor.devolver_user_id != user.user_id
        ">
                                <i class="fas fa-user"></i>
                                <span v-if="cartao.executor &&
                                    cartao.executor.devolver_user_id != null &&
                                    cartao.executor.devolver_user_id != user.user_id
                                    ">Devolver</span>
                                <span v-else>Encaminhar</span>
                            </b-button>
                            <b-button block v-b-tooltip.hover.left v-else-if="cartao.executor && cartao.executor.devolver_executor.name
                                " :title="`Devolver para ${cartao.executor.devolver_executor.name}`"
                                variant="outline-secondary" @click.prevent="devolver()">
                                <i class="fas fa-user"></i> Devolver
                            </b-button>
                        </div>

                        <div class="form-group">
                            <b-button v-b-tooltip.hover.left title="Adicionar Situação" variant="outline-secondary"
                                type="button" block @click.prevent="
                                    setCurrentModal({
                                        id: 'situacao',
                                        title: 'Adicionar Situação',
                                        size: 'sm',
                                        component: {
                                            props: {
                                                tarefa_id: cartao.tarefa_id,
                                            },
                                        },
                                        bvModal: $bvModal,
                                    })
                                    ">
                                <i class="fas fa-tag"></i> Situação
                            </b-button>
                        </div>
                        <div class="form-group">
                            <b-button v-b-tooltip.hover.left title="Adicionar Checklist" variant="outline-secondary"
                                @click.prevent="
                                    setCurrentModal({
                                        id: 'checklist',
                                        title: `Adicionar checklist`,
                                        form: 'formChecklist',
                                        size: 'md',
                                        btn_save: true,
                                        btn_save_name: `<i class='fas fa-plus'></i> Adicionar`,
                                        component: {
                                            props: {
                                                cliente_id: cartao.loja_id,
                                                tarefa_id: cartao.tarefa_id,
                                            },
                                        },
                                        bvModal: $bvModal,
                                    })
                                    " type="button" block>
                                <i class="fas fa-check-square"></i> Checklist
                            </b-button>
                        </div>
                        <div class="form-group">
                            <b-button v-b-tooltip.hover.left title="Adicionar anexo" variant="outline-secondary"
                                type="button" block @click.prevent="
                                    setCurrentModal({
                                        id: 'anexos',
                                        title: `Anexos do Cliente: ${cartao.cliente.razao_social != null &&
                                            cartao.cliente.razao_social != ''
                                            ? cartao.cliente.razao_social
                                            : cartao.cliente.nome_loja
                                            }`,
                                        component: {
                                            props: {
                                                tarefa_id: cartao.tarefa_id,
                                                parent_name: 'tarefas',
                                                parent_id: cartao.tarefa_id,
                                                showForm: true,
                                                selecionar: true,
                                                BlockThisAnexos: cartao.anexos,
                                                cliente_documento: cartao.cliente.cliente_documento,
                                            },
                                        },
                                        bvModal: $bvModal,
                                    })
                                    ">
                                <i class="fas fa-upload"></i> Anexo
                            </b-button>
                        </div>
                    </div>
                    <hr />
                    <div class="form-group">
                        <div>
                            <div class="form-group d-none">
                                <button type="button" class="btn btn-default btn-block" data-toggle="modal"
                                    data-route="processos" data-route-action="loadFormNotifications" data-id="16762"
                                    data-target="#SecondModal" title="Histórico" data-btn="false" data-modal-size="md">
                                    <i class="fa fa-edit"></i> Histórico
                                </button>
                            </div>
                            <div class="form-group">
                                <b-button v-b-tooltip.hover.left title="Liga tarefa a processo" variant="outline-secondary"
                                    type="button" block @click.prevent="
                                        setCurrentModal({
                                            id: 'LigarProcesso',
                                            title: `Ligar tarefa a processo`,
                                            size: 'lg',
                                            btn_save: true,
                                            form: 'formProcesso',
                                            component: {
                                                props: {
                                                    cartao,
                                                },
                                            },
                                            bvModal: $bvModal,
                                        })
                                        ">
                                    <span v-if="cartao.tabela_nome && cartao.tabela_id"><i class="fas fa-link"></i>
                                        Ligado com processo</span>
                                    <span v-else><i class="fas fa-unlink"></i> Abrir / Ligar a
                                        processo</span>
                                </b-button>
                            </div>
                            <div class="form-group" v-if="cartao.tabela_nome == 'processos' ||
                                cartao.tabela_nome == 'alvaras'
                                ">
                                <b-button type="button" data-form="lembrete_processo" block variant="outline-secondary"
                                    @click="$bvModal.show('lembrete')" :data-id="cartao.tabela_id" title="Lembrete">
                                    <i class="fa fa-sticky-note" v-bind:class="cartao.processo &&
                                        cartao.processo.lembrete &&
                                        cartao.processo.lembrete.lembrete
                                        ? 'text-warning'
                                        : ''
                                        "></i>
                                    Lembrete
                                </b-button>
                            </div>
                            <div class="form-group" v-if="cartao.arquivado == 0 && permissao()">
                                <b-button v-b-tooltip.hover.left type="button" block variant="outline-dark"
                                    @click.prevent="finalizar()" title="Finalizar e arquivar a tarefa">
                                    <i class="fas fa-clipboard-check"></i>
                                    <span>Finalizar tarefa</span>
                                </b-button>
                            </div>
                            <div class="form-group" v-if="cartao.arquivado == 1">
                                <b-button v-b-tooltip.hover.left type="button" block variant="danger"
                                    @click.prevent="deletar()" title="Deletar tarefa">
                                    <i class="fas fa-trash"></i>
                                    <span>DELETAR</span>
                                </b-button>
                            </div>
                            <div class="form-group" v-if="user.user_id == 7 || user.user_parent_id == 7">
                                <b-button v-b-tooltip.hover.left type="button" block variant="outline-dark"
                                    @click.prevent="window_visible = true" title="Chat">
                                    <i class="fas fa-chat"></i>
                                    <span>Chat</span>
                                </b-button>
                            </div>
                            <div class="form-group"></div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <b-button variant="outline-secondary" @click.prevent="
                        setCurrentModal({
                            id: 'restaurar',
                            title: `Restaurar Projeto/Processo`,
                            size: 'md',
                            btn_save: true,
                            form: 'restaurarForm',
                            component: {
                                props: {
                                    tarefa_id: cartao.tarefa_id,
                                },
                            },
                            bvModal: $bvModal,
                        })
                        "><i class="fas fa-undo"></i> Restaurar Projeto/Processo</b-button>
                </div>
            </div>
        </div>
        <modal id="processo">
            <ModalProcesso id="123"></ModalProcesso>
        </modal>
        <modal id="departamento-select" title="Alterar Departamento" form="DepartamentoSelectForm" btn_save size="md">
            <departamento-select :tarefa_id="tarefa_id" :departamento_id="departamento_id" @getCartao="getCartao(true)"></departamento-select>
        </modal>

        <modal id="servicos" size="lg" :title="`Serviços da tarefa: ${cartao.titulo}`">
            <Servicos :tarefa_id="tarefa_id" :cliente_id="cartao.loja_id"></Servicos>
        </modal>
        <modal v-if="currentModal" v-bind="currentModal">
            <component :is="currentModal.id" v-bind="currentModal.component.props" @updateCartao="updateCartao()"
                @getCartao="getCartao(true)" @arquivoSelecionado="arquivoSelecionado"></component>
        </modal>
        <modal id="lembrete" title="Lembrete do processo" btn_save form="lembreteForm" size="md">
            <lembrete parent_name="processos" :parent_id="Number(cartao.tabela_id)" @updated="updateCartao()" />
        </modal>
        <eFilePreview v-if="visualizar.id != ''" :title="visualizar.name" :id="`preview-${visualizar.id}`"
            :file="visualizar.link" />


        <window v-if="window_visible" @close="window_visible = false" @minimized="window_visible = false">
            <ReactFrame :cliente_id="cartao.loja_id"></ReactFrame>
        </window>
    </div>
</template>


<script>
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";

import Comentario from "../forms/Comentario.vue";
import Comentarios from "@components/tarefas/Comentarios.vue";

import Gestor from "../forms/Gestor.vue";
import Servicos from "@components/financeiro/Servicos.vue";

import Encaminhar from "../forms/Encaminhar.vue";
import Duracao from "../forms/Duracao.vue";
import Categoria from "../forms/Categoria.vue";
import Situacao from "../forms/Situacao.vue";
import Checklist from "../forms/Checklist.vue";
import Checklists from "../forms/Checklists.vue";
import eFilePreview from "../../sistema/eFilePreview.vue";
import LigarProcesso from "../forms/LigarProcesso.vue";
import Restaurar from "../forms/Restaurar.vue";
import Lembrete from "../../sistema/Lembrete.vue";

import Subcategoria from "../forms/Subcategoria.vue";
import { mapMutations, mapState } from "vuex";
import Anexos from "../../sistema/Anexos.vue";

import ReactFrame from "../../notifications/ReactFrame.vue";
import Window from "../../sistema/Window.vue";

import DepartamentoSelect from "../../departamentos/forms/DepartamentoSelect.vue";

export default {
    components: {
        Trumbowyg,
        Comentario,
        Comentarios,
        Gestor,
        Categoria,
        Subcategoria,
        Servicos,
        Encaminhar,
        Duracao,
        Restaurar,
        Situacao,
        Checklist,
        Checklists,
        eFilePreview,
        Anexos,
        LigarProcesso,
        Lembrete,
        ReactFrame,
        Window,
        DepartamentoSelect,        
    },
    data() {
        return {
            departamento_id: null,
            window_visible: false,
            visualizar: {
                id: "",
                name: "",
                link: "",
            },
            comentario: null,
            cartao: {
                descricao: null,
            },
            cobranca_btn_colors: 'outline-secondary',
            anexo: null,
            editar_descricao: false,
            editor_config: {
                plugins: {
                    allowTagsFromPaste: {
                        allowedTags: ["h4", "p", "br"],
                    },
                },
                autogrow: true,
                btns: [
                    ["undo", "redo"], // Only supported in Blink browsers
                    ["formatting"],
                    ["strong", "em"],
                    ["link"],
                    ["insertImage"],
                    ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
                    ["unorderedList", "orderedList"],
                    ["removeformat"],
                ],
            },
            TitleInput: false,
            duracao_input: false,
            data_input: false,

            subcategorias: [],
            btn_editar_categoria: false,
        };
    },
    props: {
        tarefa_id: "",
    },
    created() {
        if (this.tarefa_id) this.getCartao();


        if (this.parceiro.user_id == 7) {
            this.getServicosAndBoletos();
        }
    },

    computed: {
        ...mapState("modal", ["currentModal"]),
        ...mapState("user", ["user", "parceiro"]),
    },
    methods: {
        ...mapMutations("datatable", ["setReload"]),
        ...mapMutations("modal", ["setCurrentModal"]),

        trumbowygPaste(value) {
            $(".trumbowyg-textarea").trigger("tbwchange");
        },


        async getServicosAndBoletos() {
            const result = await this.$api.get(`tarefa/servicos/${this.tarefa_id}`);

            if (result.data.length > 0) {
                const vendas = result.data

                if (vendas.some(venda => venda.vendas.some(item => item.status_id == '7'))) {
                    this.cobranca_btn_colors = 'danger';
                } else if (vendas.some(venda => venda.vendas.some(item => item.status_id == '5'))) {
                    this.cobranca_btn_colors = 'primary';
                } else if (vendas.every(venda => venda.vendas.every(item => item.status_id == '11'))) {
                    this.cobranca_btn_colors = 'success';
                }

            }
        },





        arquivoSelecionado(arquivo) {
            this.anexo = arquivo;
            this.comentario = arquivo.arquivo_name;
            this.cartao.anexos = null;
            this.addComentario();
        },

        async addComentario() {
            const tarefa_id = this.tarefa_id;
            const result = await this.$api.post("tarefa/addComentario", {
                action_id: 5,
                comentario: this.comentario,
                anexo: this.anexo,
                tarefa_id,
            });
            this.anexos = [];
            this.anexo = null;

            this.$root.$emit('getComentarios');
            this.getCartao();
        },

        IsCanView(anexo) {
            let visualizar = false;
            switch (anexo.arquivo_name.split(".").pop()) {
                case "png":
                case "jpg":
                case "jpeg":
                case "gif":
                case "txt":
                case "doc":
                case "docx":
                case "pdf":
                    visualizar = true;
                    break;
            }

            return visualizar;
        },
        async preview(anexo) {
            const result = await this.$api.get(`anexos/${anexo.id}`);

            this.visualizar.id = "";
            this.visualizar.link = "";
            this.visualizar.name = anexo.arquivo_name;
            this.visualizar.id = anexo.id;
            this.visualizar.link = result.data.link;

            setTimeout(() => {
                this.$bvModal.show(`preview-${this.visualizar.id}`);
            }, 100);
        },
        async getCartao(update = false) {
            const result = await this.$api.get(`tarefa/${this.tarefa_id}`);
            this.cartao = result.data;
            if (this.cartao) {
                if (update) {
                    this.setReload(true);
                    this.$root.$emit('getComentarios');
                }
                this.$emit("getCategorias");
                if (!!this.cartao.categoria_id)
                    this.$emit("getSubcategorias", this.cartao.categoria_id);

                if (this.cartao.descricao) {
                    this.editar_descricao = false;
                } else {
                    this.editar_descricao = true;
                }
            }
        },
        updateDescricao() {
            this.editar_descricao = false;
            this.updateCartao();
        },
        async updateCartao() {
            const tarefa_id = this.cartao.tarefa_id;

            const result = await this.$api.put(`tarefa/${tarefa_id}`, this.cartao);
            this.getCartao(true);
        },

        async setCategoria(value) {
            const tarefa_id = this.cartao.tarefa_id;
            const categoria_id = value;
            await this.$api.put("tarefa/setCategoria", {
                tarefa_id,
                subcategoria_id: null,
                categoria_id,
            });
            // this.getSubcategorias(this.cartao.categoria_id);
            this.getCartao();
        },

        async setSubcategoria(value) {
            const tarefa_id = this.cartao.tarefa_id;
            const subcategoria_id = value;
            await this.$api.put("tarefa/setSubcategoria", {
                tarefa_id,
                subcategoria_id,
            });
            this.getCartao();
        },
        addCategoria(value) {
            this.cartao.categoria_id = value.id;
            this.setCategoria();
        },
        addSubcategoria(value) {
            this.cartao.subcategoria_id = value.id;
            this.setSubcategoria();
        },
        verificarStatusColorTempoDecorrido() {
            if (parseInt(this.cartao.duracao)) {
                if (
                    parseInt(this.cartao.tempo_decorrido) > parseInt(this.cartao.duracao)
                )
                    return "text-danger";
                if (
                    parseInt(this.cartao.tempo_decorrido) == parseInt(this.cartao.duracao)
                )
                    return "text-warning";
            }
            return "text-dark";
        },

        async devolver() {
            await this.$api.put(`tarefa/devolver/${this.cartao.tarefa_id}`, {
                tarefa_executor: this.cartao.executor.id,
                devolver_user_id: this.cartao.executor.devolver_executor.user_id,
            });

            this.getCartao(true);
            this.$root.$emit('getComentarios');
            this.$bvModal.hide("tarefaEdit");
        },

        async finalizar() {
            await this.$api.put(`tarefa/finalizar/${this.cartao.tarefa_id}`);
            this.setReload(true);
            this.$emit("reloadCartoes");

            this.$bvModal.hide("tarefaEdit");
        },

        permissao() {
            return (
                this.user.user_function == 1 ||
                this.cartao.criador_por_user_id == this.user.user_id ||
                (this.cartao.executor &&
                    this.cartao.executor.devolver_executor == this.user.user_id) ||
                (this.cartao.executor &&
                    this.cartao.executor.fk_executor_id == this.user.user_id &&
                    this.cartao.executor.devolver_executor == null)
            );
        },
        deletar() {
            this.$swal({
                title: `A tarefa id ${this.cartao.tarefa_id} será deletada e todos os seus dados serão perdidos. Deseja continuar?`,
                showDenyButton: true,
                confirmButtonText: "Sim",
                denyButtonText: `Não`,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.deletarTarefa(this.cartao.tarefa_id);
                }
            });
        },
        async deletarTarefa(id) {
            await this.$api.delete(`tarefa/${id}`);
            this.setReload(true);
            this.$bvModal.hide("tarefaEdit");
        },
    },

};
</script>

<style lang="scss" scoped>
::v-deep {
    .atwho-panel {
        top: 0 !important;
    }
}
</style>
